export default {"src":"/_next/static/media/pros.ffa63b75.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};